// Layout common para páxinas estáticas/informativas (Termos, Privacidade,
// Sitemap, Axuda, etc.). Inspirado no ContentPage.jsx de leyro.es.

import { ChevronRight } from 'lucide-react';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export interface ContentPageProps {
  title: string;
  intro?: string;
  /** Breadcrumb segment shown after "Inicio › ". Optional. */
  category?: string;
  /** Date string for "Actualizado o …". Optional. */
  updatedAt?: string;
  children: ReactNode;
}

export default function ContentPage({
  title,
  intro,
  category,
  updatedAt,
  children,
}: ContentPageProps) {
  return (
    <main className="max-w-3xl mx-auto px-6 py-12">
      {/* Breadcrumb */}
      <nav className="text-xs text-muted mb-6 flex items-center gap-1" aria-label="Breadcrumb">
        <Link to="/marketplace" className="hover:text-rauxa">
          Inicio
        </Link>
        {category ? (
          <>
            <ChevronRight size={12} aria-hidden />
            <span>{category}</span>
          </>
        ) : null}
        <ChevronRight size={12} aria-hidden />
        <span className="text-dark">{title}</span>
      </nav>

      <header className="mb-8 pb-6 border-b border-border">
        <h1 className="text-4xl font-extrabold text-dark leading-tight">{title}</h1>
        {intro && <p className="mt-3 text-lg text-muted leading-relaxed">{intro}</p>}
        {updatedAt && <p className="mt-3 text-xs text-muted">Actualizado o {updatedAt}.</p>}
      </header>

      <article className="prose-content text-sm text-dark leading-relaxed space-y-5">
        {children}
      </article>
    </main>
  );
}
